import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";

export class Catillionare_2Screen extends SlotGameType1_2Screen
{
	// override default factory with one that creates custom freegame
	
	//protected panelFactory:IPanelFactory = new CatillionarePanelFactory();
	protected override helpFactory:IHelpFactory = new CatillionareHelpFactory();

	//LED COLOR
	protected override ColorLed:string="255,0,128\n";
	constructor(multigameParams: MultigameParams, initData: SlotGameInitData) 
	{
		super(multigameParams, initData, "Catillionare");
		this.spinnableReelsParams.topBorderWidth=6;
		this.spinnableReelsParams.bottomBorderWidth=6;
	}

	// public PrepareFont(resourceManager: ResourceManager)
	// {
	// 	resourceManager.Add(new FontResource(this.basepath + "resources/Monky Stone.ttf", "."+ this.resid.ScopedResourceName("font")));
	// 	resourceManager.Add(new FontResource(this.basepath + "resources/Monky Stone.ttf", "."+ this.resid.ScopedResourceName(["lines", "font"])));
	// }
}

//Panel Colorized
class CatillionarePanelFactory implements IPanelFactory
{
	public CreateNewPanel(params: PanelParams):Panel
	{
		return new CatillionarePanel(params);
	}
}

class CatillionarePanel extends Panel
{
	protected override ButtonBackground():ButtonColors
	{
		let color:ButtonColors ={
			backgroundButtonColor: "linear-gradient(rgb(38, 21, 15),rgb(89, 55, 35), rgb(140, 101, 66),rgb(89, 55, 35),rgb(38, 21, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor:"linear-gradient(to left , transparent, HoneyDew,transparent ) 0 10 100%",
		};
		return color;
		
	}

}

//Help Colorized
class CatillionareHelpFactory implements IHelpFactory
{
	public CreateNewHelp(params: HelpParameters):Help
	{
		return new   CatillionareHelp(params);
	}
}

class CatillionareHelp extends Help
{
	protected override BackgroundPanel():HelpPanelColor
	{
		let color:HelpPanelColor = {
			backgroundPanelColor: "linear-gradient(rgb(38, 21, 15),rgb(89, 55, 35), rgb(140, 101, 66),rgb(89, 55, 35),rgb(38, 21, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};

		return color;
	}
}
